import Cookies from 'js-cookie';

import { SERVICE_MAIL, SERVICE_HOURS, MAIL_BODY_DEFAULT } from '../../constants/service';
import { COOKIE_CHOCOMEMBER_ID } from '../../constants/cookie';

/**
 *
 * @param {string} subject
 * @param {string} body
 */
export const contactCustomerService = (subject = '', body = '') => {
  window.open(`mailto:${SERVICE_MAIL}?subject=[Web]%20${subject}&body=${body}%0D%0A${SERVICE_HOURS}`);
};

/**
 *
 * @param {string} mailSubjcet
 * @note  使用 MAIL_BODY_DEFAULT 有多處，因此另外寫 function
 */
export const contactForDefault = (mailSubject) => {
  const accountId = Cookies.get(COOKIE_CHOCOMEMBER_ID);
  
  const mailBody = `會員編號：${accountId ?? '（未登入）'}%0D%0A${MAIL_BODY_DEFAULT}`;

  contactCustomerService(mailSubject, mailBody);
};
